import { render, staticRenderFns } from "./biz-data-add-or-update.vue?vue&type=template&id=6d8a8b60"
import script from "./biz-data-add-or-update.vue?vue&type=script&lang=js"
export * from "./biz-data-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./biz-data-add-or-update.vue?vue&type=style&index=0&id=6d8a8b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports